import {combineReducers} from 'redux';
import {getUsersReducer} from './getUsers'
import {getUserCreateInvoceFilesReducer} from '../../../addSession/store/reducers/getUserFiles'
import {openCAseReducer } from './openCase';
const reducer = combineReducers({
   openCAseReducer,getUsersReducer,getUserCreateInvoceFilesReducer 
    });
    
    export default reducer;
